import styled from 'styled-components';

export const StarsRow = styled.div`
  position: relative;
  display: flex;
  gap: 6px;
  justify-content: center;
`;

export const HoverValue = styled.span`
  position: absolute;
  top: -18px;
  right: 0;
  font-size: 12px;
  font-weight: 700;
  color: #ffc83d;
  background: rgba(0, 0, 0, 0.55);
  padding: 1px 6px;
  border-radius: 6px;
  pointer-events: none;
  white-space: nowrap;
`;

export const StarWrap = styled.span`
  position: relative;
  display: inline-flex;
  cursor: pointer;
`;

export const Star = styled.span<{ $on: boolean }>`
  font-size: 27px;
  color: ${({ $on }) => ($on ? '#FFC83D' : 'rgba(255,255,255,.22)')};
  transition: all 0.12s;
  line-height: 1;
  ${({ $on }) => $on && 'text-shadow: 0 0 10px rgba(255,200,61,.4);'}
`;

export const StarHalf = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  overflow: hidden;
  pointer-events: none;
`;

export const StarsQuestion = styled.div`
  font-size: 11.5px;
  color: #8aa090;
  text-align: center;
  margin-top: 6px;
  line-height: 1.4;
  font-style: italic;
`;
